module.exports = __webpack_public_path__ + "img/Dantam Hair 11.b6775c8b.jpg";